import axios from "axios";

const api = axios.create({
    baseURL: 'https://nigervoyagebackend.sesamehosting.com',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    withCredentials: false
});



api.interceptors.request.use(async (config) => {
    const tokensString = localStorage.getItem('auth_tokens');
    if (tokensString) {
        const tokens = JSON.parse(tokensString);
        if (tokens.access) {
            config.headers['Authorization'] = `Bearer ${tokens.access}`;
        }
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Vérifier si c'est une erreur 401 et si on n'a pas déjà essayé de rafraîchir
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            
            // Ne pas essayer de rafraîchir si c'est déjà une requête de refresh
            if (originalRequest.url.includes('/api/token/refresh/')) {
                console.log('Refresh token invalide ou expiré');
                localStorage.removeItem('auth_tokens');
                localStorage.removeItem('credentials');
                // Rediriger vers la page de connexion
                window.location.href = '/login';
                return Promise.reject(error);
            }

            try {
                const tokensString = localStorage.getItem('auth_tokens');
                if (tokensString) {
                    const tokens = JSON.parse(tokensString);
                    
                    // Créer une nouvelle instance axios pour éviter la boucle
                    const refreshResponse = await axios.post(
                        `${api.defaults.baseURL}/api/token/refresh/`,
                        { refresh: tokens.refresh },
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }
                    );

                    if (refreshResponse.data.access) {
                        const newTokens = {
                            ...tokens,
                            access: refreshResponse.data.access
                        };
                        localStorage.setItem('auth_tokens', JSON.stringify(newTokens));
                        originalRequest.headers['Authorization'] = `Bearer ${refreshResponse.data.access}`;
                        return api(originalRequest);
                    }
                }
            } catch (refreshError) {
                console.error('Erreur refresh token:', refreshError);
                localStorage.removeItem('auth_tokens');
                localStorage.removeItem('credentials');
                // Rediriger vers la page de connexion
                window.location.href = '/login';
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);

export default api;